export default {"src":"/_next/static/media/name_mismatch_error.ec2cce80.svg","height":120,"width":147,"blurWidth":0,"blurHeight":0};